<template>
  <div class="page-wrap">
    <!-- ========== 顶部导航栏 ========== -->
    <div class="page-header">
      <div class="header-left">
        <div v-if="isMobile" class="hamburger-btn" @click="mobileMenuDrawer = true">
          <i class="el-icon-menu"></i>
        </div>
      </div>
      <div></div>
    </div>

    <!-- PC端左侧菜单 -->
    <template v-if="!isMobile">
      <LeftSide @openSubMenu="openSubMenu" class="left-sidebar" />
    </template>

    <!-- 移动端抽屉侧边栏 -->
    <el-drawer v-model="mobileMenuDrawer" direction="ltr" size="240px" :with-header="false">
      <LeftSide
        @openSubMenu="
          openSubMenu
          mobileMenuDrawer = false
        "
      />
    </el-drawer>

    <!-- 主体内容区域 -->
    <div class="main-content">
      <!-- 顶部标题 -->
      <div class="page-top-title">
        <h1>
          欢迎登录
          <span class="blue-word">
            <img src="../assets/log/logo.png" alt="" style="width: 200px; margin-bottom: -20px" />
          </span>
        </h1>
      </div>

      <div class="func-row">
        <FuncBtn v-for="item in funcList" :key="item.id" :item="item" />
      </div>

      <!-- 登录卡片容器 -->
      <div class="login-card-wrap">
        <div class="login-card">
          <!-- 登录方式切换标签栏 -->
          <div class="login-tab-bar">
            <!-- <span class="login-tab" :class="{ active: loginForm.loginType === 'wx' }" @click="loginForm.loginType = 'wx'">微信扫码登录</span> -->
            <span class="login-tab" :class="{ active: loginForm.loginType === 'phone' }" @click="loginForm.loginType = 'phone'">手机验证码登录</span>
            <span class="login-tab" :class="{ active: loginForm.loginType === 'account' }" @click="loginForm.loginType = 'account'">用户名密码登录</span>
          </div>

          <div class="login-form-box">
            <!-- 微信扫码登录 -->
            <div class="wx-login-box" v-if="loginForm.loginType === 'wx'">
              <div class="qrcode-area">
                <i class="el-icon-qrcode qr-icon"></i>
              </div>
              <p class="qr-tip">使用微信扫描上方二维码完成登录</p>
            </div>

            <!-- 手机验证码登录 -->
            <div class="phone-login-box" v-if="loginForm.loginType === 'phone'">
              <div class="input-item">
                <el-input v-model="loginForm.guest_mob" placeholder="请输入手机号" prefix-icon="el-icon-mobile-phone"></el-input>
              </div>
              <div class="input-item code-row">
                <el-input v-model="loginForm.code" placeholder="请输入验证码" prefix-icon="el-icon-key"></el-input>
                <el-button :disabled="countDown > 0 || sendCodeLoading" class="get-code-btn" size="mini" @click="checkCode">
                  {{ countDown > 0 ? `${countDown}s` : '获取验证码' }}
                </el-button>
              </div>
              <el-button type="primary" class="submit-login-btn" @click="login">登录</el-button>
            </div>

            <!-- 账号密码登录 -->
            <el-form ref="loginFormRef" :model="loginForm">
              <div class="account-login-box" v-if="loginForm.loginType === 'account'">
                <div class="input-item">
                  <el-input v-model="loginForm.guest_mob" placeholder="请输入手机号码" prefix-icon="el-icon-user"></el-input>
                </div>
                <div class="input-item">
                  <el-input v-model="loginForm.guest_password" type="password" placeholder="请输入登录密码" prefix-icon="el-icon-lock"></el-input>
                </div>
                <div class="login-extra-row">
                  <el-checkbox v-model="loginForm.remember">记住账号</el-checkbox>
                  <span class="forget-pwd">忘记密码？</span>
                </div>
                <el-button type="primary" class="submit-login-btn" @click="login">登录</el-button>
              </div>
            </el-form>
          </div>

          <div class="login-bottom-tip">
            <span>登录即代表你同意平台《用户协议》与《隐私政策》</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LeftSide from '@/components/LeftSide.vue'
import FuncBtn from '@/components/FuncBtn.vue'
export default {
  components: { LeftSide, FuncBtn },
  data() {
    return {
      isMobile: false,
      mobileMenuDrawer: false,
      sendCodeLoading: false,
      loginLoading: false,
      countDown: 0,
      timer: null,
      funcList: [],
      loginForm: {
        C_type: 'guest_login',
        guest_mob: '',
        guest_password: '',
        code: '',
        loginType: 'phone',
        remember: false
      },
      checkCodeForm: {
        C_type: 'checkCode_get',
        guest_mob: ''
      }
    }
  },
  created() {
    const expireStr = window.localStorage.getItem('smsCodeExpireTime')
    if (expireStr) {
      const expireTime = Number(expireStr)
      const now = Date.now()
      const remain = Math.ceil((expireTime - now) / 1000)
      if (remain > 0) {
        this.countDown = remain
        this.startTimer()
      } else {
        window.localStorage.removeItem('smsCodeExpireTime')
      }
    }
  },
  mounted() {
    this.checkDevice()
    window.addEventListener('resize', this.checkDevice)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkDevice)
    if (this.timer) clearInterval(this.timer)
  },
  methods: {
    checkDevice() {
      this.isMobile = window.innerWidth <= 768
      if (this.isMobile) this.mobileMenuDrawer = false
    },
    startTimer() {
      this.timer = setInterval(() => {
        this.countDown--
        if (this.countDown <= 0) {
          clearInterval(this.timer)
          window.localStorage.removeItem('smsCodeExpireTime')
        }
      }, 1000)
    },
    openSubMenu() {},
    login() {
      this.$refs.loginFormRef.validate(async (valid) => {
        if (!valid) return
        const { data: res } = await this.$http.post('api', this.loginForm)
        if (res.guest_test_Flag !== 1) return this.$message.error('Login Failure')
        this.$message.success('登录成功！')
        window.sessionStorage.setItem('token', res.token)
        window.sessionStorage.setItem('guest_mob', this.loginForm.guest_mob)
        // console.log(118, res.guest_level)
        window.sessionStorage.setItem('isMember', res.guest_level)
        // console.log(119, window.sessionStorage.getItem('isMember'))
        window.sessionStorage.setItem('tokenUserType', 3)
        this.$router.push('/index')
      })
    },
    async checkCode() {
      this.checkCodeForm.guest_mob = this.loginForm.guest_mob.trim()
      this.sendCodeLoading = true
      try {
        const { data: res } = await this.$http.post('api', this.checkCodeForm)
        if (res.reg_yn === 0) return this.$message.error('发送失败！')

        this.$message.success('验证码已发送，请注意查收')
        const expireTime = Date.now() + 6 * 1000
        window.localStorage.setItem('smsCodeExpireTime', expireTime)
        this.countDown = 6
        this.startTimer()
      } catch (err) {
        this.$message.error(err.msg || '验证码发送失败')
      } finally {
        this.sendCodeLoading = false
      }
    }
  }
}
</script>

<style scoped>
.page-header {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 56px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 24px;
  z-index: 99;
}
.header-left {
  display: flex;
}
.hamburger-btn {
  width: 36px;
  height: 36px;
  background: #fff;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  cursor: pointer;
  border: 1px solid #e8edf2;
  color: #666;
}

.page-wrap {
  background-color: #fbfcfd;
  min-height: 100vh;
  display: flex;
  padding-top: 56px;
}
.main-content {
  flex: 1;
  padding: 40px 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  box-sizing: border-box;
}

.page-top-title {
  text-align: center;
  margin-bottom: 40px;
}
.page-top-title h1 {
  font-size: 24px;
  font-weight: normal;
  color: #333;
  margin: 0;
}
.blue-word {
  color: #22b8e6;
}

.func-row {
  width: 100%;
  max-width: 520px;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px;
  margin-bottom: 24px;
}

.login-card-wrap {
  display: flex;
  justify-content: center;
  width: 100%;
}
.login-card {
  width: 410px;
  max-width: 100%;
  background: #ffffff;
  border: 1px solid #e8edf2;
  border-radius: 16px;
  padding: 30px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);
  box-sizing: border-box;
}

.login-tab-bar {
  display: flex;
  gap: 4px;
  border-bottom: 1px solid #e8edf2;
  margin-bottom: 26px;
}
.login-tab {
  flex: 1;
  text-align: center;
  padding: 10px 0;
  font-size: 14px;
  color: #777;
  cursor: pointer;
  position: relative;
}
.login-tab.active {
  color: #22b8e6;
}
.login-tab.active::after {
  content: '';
  position: absolute;
  left: 0;
  bottom: -1px;
  width: 100%;
  height: 2px;
  background-color: #22b8e6;
}

.login-form-box {
  min-height: 260px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.input-item {
  width: 100%;
  margin-top: 10px;
}
.code-row {
  display: flex;
  gap: 12px;
  align-items: center;
}
.get-code-btn {
  flex-shrink: 0;
  white-space: nowrap;
}
.submit-login-btn {
  width: 100%;
  height: 42px;
  font-size: 15px;
  background-color: #22b8e6;
  border: none;
  margin-top: 20px;
}
.submit-login-btn:hover {
  background-color: #1ea3cc;
}

.wx-login-box {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 20px 0;
  gap: 16px;
}
.qrcode-area {
  width: 160px;
  height: 160px;
  background-color: #f5f7fa;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.qr-icon {
  font-size: 72px;
  color: #999;
}
.qr-tip {
  font-size: 13px;
  color: #777;
  margin: 0;
}

.login-extra-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 13px;
  color: #777;
  margin-top: 20px;
}
.forget-pwd {
  color: #22b8e6;
  cursor: pointer;
}

.login-bottom-tip {
  text-align: center;
  margin-top: 24px;
  font-size: 12px;
  color: #999;
}

.left-sidebar {
  width: 100px;
  flex-shrink: 0;
}

/* 响应式 */
@media (max-width: 1024px) {
  .func-row {
    grid-template-columns: repeat(2, 1fr);
  }
}
@media (max-width: 768px) {
  .page-header {
    padding: 0 16px;
  }
  .main-content {
    padding: 24px 16px;
  }
  .login-card {
    padding: 20px 16px;
  }
  .code-row {
    flex-wrap: wrap;
  }
  .code-row .el-input {
    width: 100%;
  }
  .get-code-btn {
    width: 100%;
  }
  .func-row {
    grid-template-columns: repeat(2, 1fr);
  }
}
@media (max-width: 480px) {
  .func-row {
    grid-template-columns: repeat(1, 1fr);
  }
  .login-tab-bar {
    flex-wrap: wrap;
  }
  .login-tab {
    flex: none;
    width: 33%;
    font-size: 12px;
  }
}
</style>
